import * as React from "react";
const SvgClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111927"
      d="M19.547 17.954a1.127 1.127 0 0 1-1.594 1.594l-5.952-5.954-5.954 5.952a1.127 1.127 0 0 1-1.594-1.594L10.407 12 4.455 6.046a1.127 1.127 0 1 1 1.594-1.594L12 10.406l5.954-5.955a1.127 1.127 0 1 1 1.594 1.594L13.595 12z"
    />
  </svg>
);
export default SvgClose;